import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import * as SvgIcons from 'assets/svg/sprite'
import { Button } from 'components/Button/Button'
import { IconButton } from 'components/IconButton/IconButton'
import { addToast } from 'components/Toast/Toast'
import DateModal from 'components/UI/Modal/Date/DateModal'
import PriceModal from 'components/UI/Modal/Price/PriceModal'
import { useModalContext } from 'context/modalContext'
import { useUserProfile } from 'store'
import { type ICreatorPriceLimits } from 'types/interfaces/IProfile'

import { PostSchedule } from './PostSchedule'

interface PostInputsProps {
    isUploading: boolean | false
    price: number | null
    hasCategories: boolean
    setPrice: any
    scheduleDate: Date | null
    removeSchedule: any
    submitPost: () => void
    postReady: boolean
    updateDate: any
    addCategories: () => void
    toggleShareOnTwitter: (share: boolean) => void
    userShareOnTwitter: boolean
    isEditView?:boolean
}

export const PostInputs = ({
    isUploading,
    price,
    hasCategories,
    setPrice,
    submitPost,
    postReady,
    updateDate,
    scheduleDate,
    removeSchedule,
    addCategories,
    toggleShareOnTwitter,
    userShareOnTwitter,
    isEditView
}: PostInputsProps) => {
    const modalData = useModalContext()
    const userData = useUserProfile()
    const { t } = useTranslation()
    const [lastPremiumPost , setLastPremiumPost] = useState(false)
    const [lastScheduleDate, setLastScheduleDate] = useState(false)
    const [twitterShare, setTwitterShare] = useState(userShareOnTwitter)
    const creatorPriceLimits =
        userData?.role === 'model'
            ? (userData.price_limits as ICreatorPriceLimits | undefined)
            : undefined
    useEffect(() => {
    //   userData?.last_premium_post_date
 
        if(userData?.premium_post_limit > 0){
            setLastPremiumPost(true)
        }else{
            setLastPremiumPost(false)
        }

        if(userData?.last_premium_post_schedule_date){
            const lastDate = new Date(userData?.last_premium_post_schedule_date)
            const today = new Date()
            const diffTime = Math.abs(today.getTime() - lastDate.getTime())
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            if(diffDays > 7 && userData?.premium_post_limit === 0){
                setLastScheduleDate(false)
            }else{
                setLastScheduleDate(true)
            }
        }

    }, [userData])
    const togglePriceModal = () => {
        if(userData?.status === 'restricted' && userData?.role === 'model'){
            addToast('error', "Your account is restricted");
            return
        }
        if(lastPremiumPost){
            addToast('error', "You can only one premium post in a week");
            return 
        }
       modalData.addModal(
            t('setPrice'),
            <PriceModal
                updatePrice={setPrice}
                postLimit={userData?.premium_post_limit}
                priceLimits={creatorPriceLimits}
            />
        )
    }
    
    const toggleDateModal = () => {
        modalData.addModal(
            t('schedulePost'),
            <DateModal confirmFn={(val: Date) => updateDate(val)} 
            newDateVal={scheduleDate ?? new Date()}
            />
        )
    }

    const removePrice = () => setPrice(null)

    const handleToggleTwitter = () => {
        if (userData?.twitter) {
            setTwitterShare(prev => {
                const newValue = !prev
                toggleShareOnTwitter(newValue)
                return newValue
            })
        } else {
            addToast('error', t('error:addYourTwitterAccountInAccountSettings'))
        }
    }

    return (
        <div className='newpost__body__input '>
            {price ?? scheduleDate ? (
                <PostSchedule
                    price={price}
                    removePrice={removePrice}
                    scheduleDate={scheduleDate}
                    removeSchedule={removeSchedule}
                />
            ) : (
                ''
            )}
            <div className='newpost__body__input--post'>
                <div className='newpost__input__buttons'>
                {scheduleDate ? (
                    <IconButton
                    icon={<SvgIcons.IconCalendarActive />}
                    desc={t('schedulePost')}
                    clickFn={!isEditView ? toggleDateModal : undefined}
                    customClass={`newpost__input__buttons__button ${isEditView ? 'disabled' : ''}`}
                    />
                ) : (
                    <IconButton
                    icon={<SvgIcons.IconCalendarInactive />}
                    desc={t('schedulePost')}
                    clickFn={!isEditView ? toggleDateModal : undefined}
                    customClass={`newpost__input__buttons__button ${isEditView ? 'disabled' : ''}`}
                    />
                )}

                {price ? (
                    <IconButton
                    icon={<SvgIcons.IconDolarCircleActive />}
                    desc={t('setPrice')}
                    clickFn={togglePriceModal}
                    customClass='newpost__input__buttons__button'
                    />
                ) : (
                    <IconButton
                    icon={<SvgIcons.IconDolarCircleInactive />}
                    desc={t('setPrice')}
                    clickFn={togglePriceModal}
                    customClass='newpost__input__buttons__button'
                    />
                )}

                <IconButton
                    icon={<SvgIcons.IconList color={hasCategories ? '#00B3FF' : '#AFAFAF'} />}
                    desc={t('setPrice')}
                    clickFn={() => addCategories()}
                    customClass='newpost__input__buttons__button'
                />
                </div>

                <div className='newpost__input__special'>
{/*                 <IconButton
                    icon={<SvgIcons.IconTwitter color={twitterShare ? '#00B3FF' : undefined} />}
                    desc={t('postOnTwitter')}
                    clickFn={!isEditView ? handleToggleTwitter : undefined}
                    customClass={`newpost__input__buttons__button ${isEditView ? 'disabled' : ''}`}
                /> */}
                <IconButton
                    icon={<SvgIcons.IconTwitter color={twitterShare ? '#00B3FF' : undefined} />}
                    desc={t('postOnTwitter')}
                    clickFn={!isEditView ? handleToggleTwitter : undefined}
                    customClass={`newpost__input__buttons__button ${isEditView ? 'disabled' : ''}`}
                />
                <Button
                    text={t('post')}
                    color='blue'
                    font='mont-16-semi-bold'
                    height='5'
                    width='fit'
                    padding='3'
                    customClass='submitPost__button'
                    clickFn={() => submitPost()}
                    disabled={!postReady || isUploading}
                />
                </div>

            </div>
        </div>
    )
}
